import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getRum } from "../../aws-app-monitor/rum";
import { isPublicSlug } from "../../common/publicUtils";

const CANVAS_SLUG_PATTERN = /^\/canvas\/([^/]+)/;

export const PublicCanvasRumTracker: React.FC = () => {
  /*
    CloudWatch RUM – Public open-source canvas visitor tracking
    Fires for `/canvas/:slug` when slug is in REACT_APP_PUBLIC_PROJECTS.
    New repos need no tracking changes — only catalog + env updates.
  */
  const location = useLocation();

  useEffect(() => {
    const rum = getRum();
    if (!rum) return;

    const match = location.pathname.match(CANVAS_SLUG_PATTERN);
    const slug = match?.[1]?.trim();
    if (!slug || !isPublicSlug(slug)) return;

    const route = `/canvas/${slug}`;

    rum.recordEvent("public_canvas_view", {
      slug,
      route,
    });

    return () => {
      rum.recordEvent("public_canvas_exit", {
        slug,
        route,
      });
    };
  }, [location.pathname]);

  return null;
};
